import React from 'react';
import classNames from 'classnames';

import { QrBannerLogo } from '@/icons/index';

import Qr from '../Qr/Qr';

import styles from './QrBanner.module.scss';

const QrBlock = ({ data, className, dark = false }) => {
  return (
    <section
      className={classNames(styles['qr-banner'], className, {
        [styles.dark]: dark,
      })}
      data-testid='qrBlock'
      itemScope
      itemType='https://schema.org/Property'
    >
      <div className={styles['qr-banner__overflow']}>
        <div className={styles['qr-banner__inner']}>
          <div className={styles['qr-banner__content']}>
            {data?.pageCategory && (
              <span className={styles['qr-banner__category']}>
                {data.pageCategory}
              </span>
            )}
            {data?.title && (
              <strong className={styles['qr-banner__title']}>
                {data.title}
              </strong>
            )}
          </div>
          {data?.qrBlock && (
            <Qr className={styles['qr-banner__links']} data={data.qrBlock} />
          )}
        </div>
        <QrBannerLogo className={styles['qr-banner__bg']} />
      </div>
    </section>
  );
};

export default QrBlock;
